// extracted by mini-css-extract-plugin
export var checkboxInputRow = "v_rW";
export var checkboxInputColumn = "v_rX";
export var inputOptionRow = "v_pw";
export var inputOptionColumn = "v_px";